import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

const PittedSurfaceOutlinedSvg = () => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.9}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 8H6C6.6 10.4 8.4 10.4 9 8H12C12.5 9.8 13.5 9.8 14 8H17C17.7 10.8 19.3 10.8 20 8H21V18H3Z" />
  </svg>
);

export const PittedSurfaceOutlined = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={PittedSurfaceOutlinedSvg} {...props} />
);
